<template>
  <div>
    <v-btn
      icon
      :loading="isDownloading"
      :disabled="isDownloading"
      color="info"
      @click="download"
    >
      <v-icon>{{ mdiCloudDownload }}</v-icon>
    </v-btn>
    <v-snackbar
      v-model="showError"
      color="error"
      timeout="5000"
    >
      {{ $t('alerts.errorOccurred') }}
    </v-snackbar>
  </div>
</template>

<script>
import { mdiCloudDownload } from '@mdi/js';
import fileApi from '@/apis/file-api';

export default {
  name: 'BaseDownloadFile',
  props: {
    fileUri: {
      type: String,
      required: true,
    },
    fileNameOriginal: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDownloading: false,
      showError: false,
      mdiCloudDownload,
    };
  },
  computed: {
    downloadName() {
      return this.fileNameOriginal || this.fileUri;
    },
  },
  methods: {
    async download() {
      this.isDownloading = true;
      this.showError = false;
      try {
        const token = this.$store.getters['auth/token'];
        const response = await fileApi.requestDownload(token, this.fileUri);
        const url = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.downloadName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
      catch {
        this.showError = true;
      }
      finally {
        this.isDownloading = false;
      }
    },
  },
};
</script>
